import React from 'react';
function FilterList() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default FilterList;
